import { useIsSellerFeatureEnabled } from '../../../hooks/use-is-seller-feature-enabled';
import { InventorySync } from '../../../constants/features';
import { useFeatureFlag } from '../../../feature-flags/hooks/use-feature-flag';
import { FeatureFlagDeclarations } from '../../../feature-flags/feature-flag-declarations';
import { useCallback } from 'react';
import { syncConsolidatedInventoryCounts } from './api';

export const useProtectedSyncInventory = () => {
  const hasInventorySync = useIsSellerFeatureEnabled(InventorySync);
  const shouldSyncInventoryOnOrderImport = useFeatureFlag(FeatureFlagDeclarations.enableSyncInventoryOnOrderImport);

  return useCallback(() => {
    if (hasInventorySync && shouldSyncInventoryOnOrderImport) {
      syncConsolidatedInventoryCounts();
    }
  }, [hasInventorySync, shouldSyncInventoryOnOrderImport]);
};
